<template>
  <div class="contador">
    <div
      v-for="billete in billetes"
      :key="billete.valorBillete"
      class="fila"
      :class="{ activa: Number(billete.cantidad) > 0 }"
    >
      <div class="denominacion">
        <span class="simbolo">$</span>{{ formatear(billete.valorBillete) }}
      </div>

      <div class="stepper">
        <button
          type="button"
          class="btn"
          :disabled="!Number(billete.cantidad)"
          @click="restar(billete)"
          tabindex="-1"
        >
          <v-icon small>mdi-minus</v-icon>
        </button>
        <input
          type="number"
          min="0"
          inputmode="numeric"
          placeholder="0"
          v-model.number="billete.cantidad"
          @focus="$event.target.select()"
          @input="emitir"
        />
        <button type="button" class="btn" @click="sumar(billete)" tabindex="-1">
          <v-icon small>mdi-plus</v-icon>
        </button>
      </div>

      <div class="subtotal" :class="{ vacio: !Number(billete.cantidad) }">
        $ {{ formatear(subtotal(billete)) }}
      </div>
    </div>
  </div>
</template>

<script>
// Conteo de efectivo por denominación. Emite `input` con el detalle
// [{ valorBillete, cantidad }] cada vez que cambia, en el formato que el
// backend espera en `detalle` al abrir y cerrar el arqueo.
// `inicial` precarga un conteo ya hecho (mismo formato) para poder retocarlo.
export default {
  name: "ContadorBilletes",
  props: {
    denominaciones: {
      type: Array,
      default: () => [20000, 10000, 2000, 1000, 500, 200, 100, 50, 20, 10, 5],
    },
    inicial: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const previo = (v) => this.inicial.find((b) => Number(b.valorBillete) === v);
    return {
      billetes: this.denominaciones.map((v) => ({
        valorBillete: String(v),
        cantidad: previo(v) ? Number(previo(v).cantidad) : null,
      })),
    };
  },
  mounted() {
    if (this.inicial.length) this.emitir();
  },
  methods: {
    formatear(valor) {
      return new Intl.NumberFormat("es-AR").format(Number(valor) || 0);
    },
    subtotal(billete) {
      return (Number(billete.cantidad) || 0) * Number(billete.valorBillete);
    },
    sumar(billete) {
      billete.cantidad = (Number(billete.cantidad) || 0) + 1;
      this.emitir();
    },
    restar(billete) {
      billete.cantidad = Math.max((Number(billete.cantidad) || 0) - 1, 0);
      this.emitir();
    },
    emitir() {
      this.$emit("input", this.billetes);
    },
  },
};
</script>

<style scoped>
.contador {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px 10px;
}
@media (max-width: 640px) {
  .contador {
    grid-template-columns: 1fr;
  }
}
.fila {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  min-width: 0;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid transparent;
  transition: background 0.15s, border-color 0.15s;
}
.fila.activa {
  background: rgba(186, 107, 48, 0.08);
  border-color: rgba(186, 107, 48, 0.35);
}
.denominacion {
  font-size: 15px;
  white-space: nowrap;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #e6e6e6;
}
.simbolo {
  opacity: 0.45;
  margin-right: 3px;
  font-weight: 400;
}
.stepper {
  display: flex;
  align-items: center;
  gap: 4px;
}
.btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  background: rgba(255, 255, 255, 0.07);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.12s;
}
.btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.14);
}
.btn:active:not(:disabled) {
  background: rgba(186, 107, 48, 0.35);
}
.btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.stepper input {
  width: 52px;
  height: 36px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: #121212;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  outline: none;
  -moz-appearance: textfield;
}
.stepper input:focus {
  border-color: #BA6B30;
  box-shadow: 0 0 0 3px rgba(186, 107, 48, 0.2);
}
.stepper input::-webkit-outer-spin-button,
.stepper input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.subtotal {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-size: 13px;
  white-space: nowrap;
  color: #e3b08a;
}
.subtotal.vacio {
  color: rgba(255, 255, 255, 0.25);
}
</style>
